import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import { firebaseAuth } from '../../providers/AuthProvider';

const ForgotPassword = () => {
  const { inputs, setInputs, errors, setErrors, user, handleSignout } =
    useContext(firebaseAuth);

  useEffect(() => {
    if (user?.isAuthenticated) handleSignout();
  }, [user, handleSignout]);

  useEffect(() => {
    setInputs({ email: '', finished: false });
    setErrors([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const forgotPassword = firebase.functions().httpsCallable('appV2/forgotPassword');
      await forgotPassword(inputs.email);
    } catch (err) {
      console.error('forgotPassword failed', err);
    } finally {
      setInputs((prev) => ({ ...prev, finished: true }));
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setInputs((prev) => ({ ...prev, [id]: value }));
  };

  if (inputs.finished) {
    return (
      <div>
        <h1 className="text-xl font-semibold tracking-tight text-zinc-900 dark:text-white">Check your email</h1>
        <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">
          If an account with that address exists, a password-reset link has been sent.
          The link expires in about an hour.
        </p>
        <div className="mt-6">
          <Link
            to="/manage/sign-in"
            className="text-sm font-semibold text-zinc-900 hover:text-zinc-700 dark:text-white dark:hover:text-zinc-300"
          >
            Back to sign-in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-xl font-semibold tracking-tight text-zinc-900 dark:text-white">Forgot password</h1>
      <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">
        Enter the email on file and we'll send you a reset link.
      </p>
      <form onSubmit={handleSubmit} className="mt-6 space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-zinc-700 dark:text-zinc-300">
            Email address
          </label>
          <input
            id="email"
            type="email"
            required
            onChange={handleChange}
            className="mt-2 block w-full rounded-md bg-zinc-50 px-3 py-2 text-sm text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-zinc-900 dark:bg-zinc-800/60 dark:text-white dark:ring-white/10 dark:placeholder:text-zinc-500 dark:focus:ring-white"
          />
        </div>
        <button
          type="submit"
          className="inline-flex w-full items-center justify-center rounded-md bg-zinc-900 px-3 py-2 text-sm font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100"
        >
          Send reset email
        </button>
        <div className="text-sm">
          <Link to="/manage/sign-in" className="text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white">
            Back to sign-in
          </Link>
        </div>
        {errors[0] && (
          <div className="rounded-md bg-red-500/10 px-3 py-2 text-sm text-red-700 ring-1 ring-inset ring-red-500/30 dark:text-red-300 dark:ring-red-500/20">
            {errors[0]}
          </div>
        )}
      </form>
    </div>
  );
};

export default ForgotPassword;
